module.exports = __webpack_public_path__ + "img/websiteSize.93573861.svg";